import { useHasFF } from 'venn-utils';
import { useRecoilValue } from 'recoil';
import {
  blockExcelFunction,
  getSortedUsedProxies,
  investmentProxiesStateForExport,
  StudioExcelExportKeys,
  type UsedProxyWithParents,
  useScopedSetRecoilState,
} from 'venn-state';
import { useCallback, useEffect, useMemo } from 'react';
import { convertProxiesToExcel } from './excel-transformers/convertProxiesToExcel';

export const useProxyXLSExport = () => {
  const usedProxies = useRecoilValue(investmentProxiesStateForExport);
  const holdingProxyFF = useHasFF('holding_proxy_ff');
  const hasLayeredProxyFF = useHasFF('layered_proxy_picker_ff');

  const sortedUsedProxies: { [p: string]: UsedProxyWithParents[] } = useMemo(
    () => getSortedUsedProxies(usedProxies),
    [usedProxies],
  );

  const excelFunction = useCallback(
    () => convertProxiesToExcel(sortedUsedProxies, holdingProxyFF, hasLayeredProxyFF),
    [sortedUsedProxies, holdingProxyFF, hasLayeredProxyFF],
  );

  const setExportFunction = useScopedSetRecoilState(blockExcelFunction(StudioExcelExportKeys.PROXY));

  useEffect(() => {
    setExportFunction({ excelFunction });
  }, [setExportFunction, excelFunction]);
};
